import React, { useEffect } from "react";
import { ClickableChip } from "../../../global/chips/ClickableChip";
import { IExploreAllFilters } from "../../../../interfaces/globalComponents/explore/material/exploreAllFilters/IExploreAllFilters";
import { ArrowDropDown, ArrowDropUp, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Drawer, Menu } from "@mui/material";
import { FiltersList } from "./FiltersLIst";
import { DefaultModal } from "../../../global/modals/material/DefaultModal";
import { setOpenModal } from "../../../../redux/pages/exploreSlice";
import { removeAllFilters } from "../../../../redux/filtersSlice";
import { IconButton } from "../../../global/buttons/material/iconButton/IconButton";

export const ExploreAllFilters = ({
  filterFor = "listings",
  type = "objectives",
  title,
}: IExploreAllFilters) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors,
  );
  const open = useSelector((state: RootState) => state.explore.value.openModal);
  const dispatch = useDispatch();
  const selectedFilters = useSelector((state: RootState) => state.filters);
  const allFilters = useSelector((state: RootState) => state.explore.value);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.currentTarget.classList.contains("MuiIconButton-root")) {
      handleClearResults();
      return;
    }

    if (event.currentTarget.classList.contains("MuiSvgIcon-root")) {
      setAnchorEl(event.currentTarget.parentElement);
    } else {
      setAnchorEl(event.currentTarget);
    }

    if (window.innerWidth < 768) {
      dispatch(
        setOpenModal({
          bottomsheet: true,
          menu: false,
          drawer: false,
        }),
      );
    }

    if (window.innerWidth >= 768 && window.innerWidth < 1240) {
      dispatch(
        setOpenModal({
          bottomsheet: false,
          menu: false,
          drawer: true,
        }),
      );
    }

    if (window.innerWidth >= 1240) {
      dispatch(
        setOpenModal({
          bottomsheet: false,
          menu: true,
          drawer: false,
        }),
      );
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearResults = () => {
    dispatch(removeAllFilters({ filterFor, type }));
  };

  const handleLabelChip = (): string => {
    if (!allFilters.filtersList) {
      return title;
    }

    const currentFiltersList = allFilters?.filtersList[type];

    if (
      selectedFilters[filterFor][type].length > 0 &&
      (type === "levels" || type === "interests")
    ) {
      return `${
        currentFiltersList.find(
          (item) => item.value === selectedFilters[filterFor][type][0],
        ).title
      } ${
        selectedFilters[filterFor][type].length > 1
          ? `+${selectedFilters[filterFor][type].length - 1}`
          : ""
      }`;
    }

    if (
      selectedFilters[filterFor][type].length > 0 &&
      (type === "objectives" || type === "sports")
    ) {
      return `${
        currentFiltersList.find(
          (item) => item.id === selectedFilters[filterFor][type][0],
        )?.title
      } ${
        selectedFilters[filterFor][type].length > 1
          ? `+${selectedFilters[filterFor][type].length - 1}`
          : ""
      }`;
    }

    return title;
  };

  useEffect(() => {
    if (!open.bottomsheet && !open.drawer && !open.menu) {
      handleClose();
    }
  }, [open]);

  return (
    <div>
      <ClickableChip
        endIcon={
          selectedFilters[filterFor][type].length > 0 ? (
            <IconButton
              icon={<Close />}
              onClick={handleClearResults}
              className="p-0"
            />
          ) : anchorEl ? (
            <ArrowDropUp />
          ) : (
            <ArrowDropDown />
          )
        }
        label={handleLabelChip()}
        onClick={handleClick}
        isSelected={selectedFilters[filterFor][type].length > 0}
      />

      <div className="hidden lg:block rounded-[28px]">
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={anchorEl != null && open.menu}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: componentColors.surface.surfContainerLowest,
              backgroundImage: "none",
              width: "25rem",
              borderBottomLeftRadius: "28px",
              borderBottomRightRadius: "28px",
              position: "relative",
            },
          }}
        >
          <FiltersList
            filterFor={filterFor}
            type={type}
            className="h-[300px] lg:h-[400px]"
          />
        </Menu>
      </div>

      <div className="hidden md:block lg:hidden">
        <Drawer
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: componentColors.surface.surfContainerLowest,
              backgroundImage: "none",
              width: "35rem",
            },
          }}
          anchor={"right"}
          open={anchorEl != null && open.drawer}
          onClose={handleClose}
        >
          <FiltersList filterFor={filterFor} type={type} />
        </Drawer>
      </div>

      <div>
        <DefaultModal
          onClose={handleClose}
          open={anchorEl != null && open.bottomsheet}
        >
          <div className="lg:w-[50vw]">
            <FiltersList filterFor={filterFor} type={type} />
          </div>
        </DefaultModal>
      </div>
    </div>
  );
};
